import canUseDOM from "../canUseDOM/canUseDOM";
export var getOwnerDocument = function(element) {
    if (canUseDOM()) {
        return element ? element.ownerDocument : document;
    }
    return null;
};
export default getOwnerDocument;
